import React from 'react'
import { formatMessage } from 'devextreme/localization'

import ErrorPopUp from '../pop-up/error-popup'

const defaultMessage = 'Please login again.'

export default function EmbeddedAuthErrorPopup() {
  const [authError, setAuthError] = React.useState(null)

  React.useEffect(() => {
    const handleAuthError = (event) => {
      setAuthError(event.detail || { message: defaultMessage })
    }

    window.addEventListener('embedded-auth-error', handleAuthError)
    return () => window.removeEventListener('embedded-auth-error', handleAuthError)
  }, [])

  const handleClose = React.useCallback(() => {
    setAuthError(null)
  }, [])

  return (
    <ErrorPopUp
      parentCallback={handleClose}
      visible={!!authError}
      title={formatMessage('SessionExpired')}
      subTitle={authError?.message || defaultMessage}
    />
  )
}
